import { render, staticRenderFns } from "./notice-report.vue?vue&type=template&id=2a4c0162&scoped=true&"
import script from "./notice-report.vue?vue&type=script&lang=js&"
export * from "./notice-report.vue?vue&type=script&lang=js&"
import style0 from "./notice-report.vue?vue&type=style&index=0&id=2a4c0162&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4c0162",
  null
  
)

export default component.exports